export default __webpack_public_path__ + "static/3-a6883c24b5432ee45250e3812c0fc7e7.jpeg";